module.exports = __webpack_public_path__ + "static/media/imagecarousal1.04d723a1.png";